import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';

export type ProfileSideMenuItem = {
  name: string;
  icon: string;
  to?: string;
  onClick?: () => void;
}

type Props = {
  name: string;
  profilePicture?: string;
  role: string;
  uploadStorage: string;
  menu?: ProfileSideMenuItem[];
}



export class ProfileSideMenu extends React.Component<Props> {
  render() {
    let profilePicture: ReactNode = <i className="fal fa-smile-beam fa-3x fa-fw" style={{ lineHeight: "30px", width: "35px" }}></i>;
    if(this.props.profilePicture !== "") {
      profilePicture = <div className="avatar-w" style={{ width: "45px", height: "45px"}}><img alt={this.props.name} src={ this.props.profilePicture } style={{ width: "35px", height: "35px" }}/></div>;
    }
  
    // Render the profile side menu
    return (
      <div className='logged-user-w avatar-inline'>
        <div className='logged-user-i p-0'>
          <div className='text-primary'>{ profilePicture }</div>
          <div className="logged-user-info-w" style={{ cursor: "default" }}>
            <div className="logged-user-name">
              { this.props.name }
            </div>
            <div className="logged-user-role">
              { this.props.role }
              <div title="Cloud Upload"><i className="fal fa-fw fa-cloud-upload"></i> Uploaded: { this.props.uploadStorage }</div>
            </div>
            { this.renderMenu(this.props) }
          </div>
  
          <div className="logged-user-toggler-arrow" onClick={ this.toggleProfileMenu }><div className="os-icon os-icon-chevron-down"></div></div>
          <div className="logged-user-menu color-style-bright" onMouseLeave={ this.hideProfileMenu }>
            <i style={{ right: '0.25rem', top: '0.25rem' }} className='fal fa-times fa-2x text-danger position-absolute px-1' onClick={ this.toggleProfileMenu }></i>
            <div className="logged-user-avatar-info">
              <div className="text-white">{ profilePicture }</div>
              <div className="logged-user-info-w">
                <div className="logged-user-name">
                  { this.props.name }
                </div>
                <div className="logged-user-role">
                  { this.props.role }
                  <div title="Cloud Upload"><i className="fal fa-fw fa-cloud-upload"></i> Uploaded: { this.props.uploadStorage }</div>
                </div>
              </div>
            </div>
            <div className="bg-icon">
              <i className="fal fa-user"></i></div>
            <ul>
              <li onClick={ this.toggleProfileMenuItem }><Link to='/myaccount/setting/changeinfo'><i className="fal fa-cog fa-fw"></i><span>Setting</span></Link></li>
              <li onClick={ this.toggleProfileMenuItem }><Link to='/user/analytic/pageview'><i className="fal fa-analytics fa-fw"></i><span>My Analytics</span></Link></li>
              <li onClick={ this.toggleProfileMenuItem }><Link to='#' onClick={ this.logout }><i className="fal fa-sign-out-alt fa-fw"></i><span>Logout</span></Link></li>
            </ul>
          </div>
        </div>
      </div>
    );
  }

  private toggleProfileMenu = () => {
    document.querySelector(".menu-w .logged-user-menu")!.classList.toggle("show");
  }

  private hideProfileMenu = () => {
    document.querySelector(".menu-w .logged-user-menu")!.classList.remove("show");
  }

  private toggleProfileMenuItem = () => {
    document.querySelector(".menu-w .logged-user-menu")!.classList.toggle("show");
    
    if(window.innerWidth <= 768) {
      document.querySelector(".menu-w")!.classList.toggle("show");
    }
  }

  private logout = () => {
    const result = window.confirm('Do you really want to logout?');
    if(result) {
      Cookies.remove('token');
      window.location.reload();
    }
  }

  private renderMenu = (props: Props) => {
    // Do not render if there is no menu
    if (!props.menu) {
      return undefined;
    }
  
    // Render the menu
    const menuDOM = (
      <div className="logged-user-menu color-style-bright">
        <div className="logged-user-avatar-info">
          <div className="logged-user-info-w">
            <div className="logged-user-name">
              { props.name }
            </div>
            <div className="logged-user-role">
              { props.role }
            </div>
          </div>
        </div>
        <div className="bg-icon">
          <i className="os-icon os-icon-wallet-loaded"></i>
        </div>
  
        { this.renderItems(props.menu) }
      </div>
    );
  
    return menuDOM;
  }
  
  private renderItems = (menu: ProfileSideMenuItem[]) => {
    return (
      <ul>
        { menu.map(item => this.renderItem(item)) }
      </ul>
    )
  }
  
  private renderItem = (item: ProfileSideMenuItem) => {
    // If there is no to property, we ignore the click event
    if (item.to) {
      return (<li key={item.name}>
        <Link to='#'>
          <i className={ item.icon }></i>
          <span>{ item.name }</span>
        </Link>
      </li>
      )
    }
  
    return (
      <li key={item.name}> 
        <Link to="#" onClick={ item.onClick }>
          <i className={ item.icon }></i>
          <span>{ item.name }</span>
        </Link>
      </li>
    )
  }
}